import { Box, Form, FormField, FormLabel, FormError, Grid, Input } from '@plusplusminus/plusplusdash'
import { navigate, RouteComponentProps } from '@reach/router'
import { RichTextEditor } from 'components/RichTextEditor'
import { useCreateSizingGuideMutation } from 'hooks/sizingGuides'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import Button from 'components/Button'

interface FormValues {
  name: string
}

export const CreateSizingGuide: React.FC<RouteComponentProps> = () => {
  const { register, handleSubmit, errors } = useForm<FormValues>()
  const [content, setContent] = useState('')

  const { createSizingGuide, loading } = useCreateSizingGuideMutation({
    onCompleted: (data: any) => {
      toast.success('Sizing guide created')
      navigate(`/sizing-guides/${data.createOneSizingGuide.id}`)
    },
    onError: () => toast.error('Could not create sizing guide')
  })

  const onSubmit = (data: FormValues) => {
    createSizingGuide({ name: data.name, content })
  }

  return (
    <Box>
      <Box className="flex justify-between p-5 border-b border-gray-300 items-center">
        <Box>
          <h3 className="text-lg leading-6 font-medium text-gray-900">New Sizing Guide</h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">Create a sizing guide to assign to a brand</p>
        </Box>
      </Box>
      <Box className="p-5">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Grid className="mb-4" columns={1} rowGap={4}>
            <FormField direction="column">
              <FormLabel htmlFor="name">Guide Name *</FormLabel>
              <Input
                id="name"
                name="name"
                as="input"
                variant="standard"
                width="full"
                ref={register({ required: { value: true, message: 'Required' } })}
              />
              {errors.name && <FormError>{errors.name.message}</FormError>}
            </FormField>
            <FormField direction="column">
              <FormLabel>Content</FormLabel>
              <RichTextEditor value={content} onChange={setContent} />
            </FormField>
          </Grid>
          <Button
            variant="primary"
            colorScheme="green"
            type="submit"
            className="px-8"
            disabled={loading}
            isLoading={loading}
          >
            Save
          </Button>
        </Form>
      </Box>
    </Box>
  )
}
